import React, { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getPaymentAndUserInfo } from "api/payment";
import PropTypes from "prop-types";
import DynamicForm from "components/DynamicForm";
import LoadingSpinner from "lib/LoadingSpinner";

function PaymentCommonTabs({ formFields, selectedData }) {
  const userRole = sessionStorage.getItem("currentUserRole") || null;
  const loggedInUserInfo = useSelector(
    (state) => state.loggedInUserInfo?.userAuthInfo
  );

  const paymentLoader = useSelector(
    (state) => state?.paymentReducer?.fetchingPaymentDetails
  );

  const decryptedId = useSelector((state) => state?.urlEncryption?.urlId);

  
  const dispatch = useDispatch();
  const uploadedDocument = useSelector(
    (state) => state.uploadDocumentReducer?.uploadedDocument
  );
  const payment_details = useSelector(
    (state) => state.paymentReducer?.payment_details
  );

  const flattendData = {
    ...uploadedDocument,
    ...selectedData.primaryworkflow,
    ...selectedData.subworkFlowInfo,
    subworkFlowInfo: selectedData.subworkFlowInfo,
    ...selectedData,
    ...payment_details,
    payment_status: payment_details?.status,
  };

  const [formErr, setFormErr] = useState({});
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [activeTabKey, setActiveTabKey] = useState("");

  useEffect(() => {
    handleTabChange(selectedData?.[formFields?.form_field]?.[0]?.payment_id || selectedData?.[formFields?.form_field]?.[0]?._id );
  }, []);

  const evaluateValidEvalFunc = (evalString) => {
    try {
      const func = eval(evalString);
      return typeof func === "function";
    } catch (error) {
      return false;
    }
  };

  const handleTabChange = (keyValue) => {
    if (activeTabKey === keyValue) return;
    setActiveTabKey(keyValue);
    const funcToTrigger = formFields?.func_to_trigger || "";
    if (funcToTrigger && evaluateValidEvalFunc(funcToTrigger)) {
      eval(`${funcToTrigger}(keyValue)`);
    }
  };

  const handlePaymentTabChange = (value) => {
    if (value) {
      dispatch(
        getPaymentAndUserInfo({
          payment_id: value,
          user_id: decryptedId?.userId,
        })
      );
    }
  };

  const titleCase = (s) =>
    s
      ?.toString()
      ?.replaceAll("_", " ")
      ?.split(" ")
      ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      ?.join(" ");

  const clearFieldError = (fields, isList) => {
    fields = isList ? fields : [fields];
    let err = { ...formErr };

    for (let key in fields) {
      const field = fields[key];
      if (err[field] !== undefined) {
        delete err[field];
      }
    }

    setFormErr(err);
  };

  if (loading) {
    return (
      <div className="loader-container">
        <div className="loader " />
      </div>
    );
  }

  const generateFormElements = (formFields, flattendData, tabIndex) => {
    return formFields?.form_elements?.map((item, i) => {
      if (item?.type) {
        return (
          <div className="mb-3" key={`${tabIndex}-${item?.name}_${i + 1}`}>
            <DynamicForm
              formFields={item}
              selectedData={flattendData}
              tabIndex={tabIndex}
            />
          </div>
        );
      } else return null;
    });
  };

  const generateTabs = (selectedData, formFields, flattendData) => {
    return selectedData?.[formFields?.form_field]?.map((_item, index) => {
      const title = _item?.[formFields?.form_key];

      return (
        <Tab
          eventKey={_item?.payment_id}
          title={`${titleCase(title)}`}
          key={`${_item?.payment_id}-${index + 1}`}
        >
          {formFields && generateFormElements(formFields, flattendData, index)}
        </Tab>
      );
    });
  };


  if (
     paymentLoader
  ) {
    return <LoadingSpinner />;
  }

  return (
    <div className="common_tab_header">
      {!selectedData?.[formFields?.form_field]?.length && (
        <div className="p-3 px-4">
          {formFields?.no_content || "No Details Added"}
        </div>
      )}
      <Tabs
        id="controlled-tab-example"
        activeKey={activeTabKey}
        onSelect={handleTabChange}
        className={`mt-2 detail-nav-tabs border-2 border-transparent ${
          selectedData?.[formFields?.form_field]?.length > 2
            ? "overflow-x-scroll theme-scrollbar pb-2"
            : "pb-3"
        }`}
      >
        {generateTabs(selectedData, formFields, flattendData)}
      </Tabs>
    </div>
  );
}

PaymentCommonTabs.propTypes = {
  formFields: PropTypes.object,
  selectedData: PropTypes.object,
};

export default PaymentCommonTabs;
